/**
 * App Constant Values
 */

// Make all query parameters case insensitive
const newSearch = {};
(window.location.href.split('?')[1] || '').split('&').forEach((keyValPair) => {
  const keyValArray = unescape(keyValPair).split('=');
  const key = keyValArray[0];
  const value = keyValArray[1];
  newSearch[key] = value;
  newSearch[key.toLowerCase()] = value;
});

// Conditional flags
const isDevelopment = window.location.origin.startsWith('https://localhost') || window.location.origin.startsWith('https://studio.logictry.localhost');
const isApp = window.parent === window.self && window.self === window.top && !window.frameElement;
const isIphone = window.logictry && window.logictry.isIphone;
const isWidget = !isApp;
const isLogicWiki = ['https://logictry.com', 'capacitor://localhost', 'https://localhost', 'https://localhost:3000'].includes(window.location.origin);

const ua = navigator.userAgent.toLowerCase();
const isAndroid = ua.includes("android");
const isIOS = /iphone|ipad|ipod/.test(ua);

const documentReferrer = document.referrer && document.referrer.split( '/' )[2].split(':')[0];
const { apikey } = newSearch;

let isWidgetOnSameDomain = false;
if (isWidget) {
  try {
    // Check if window.parent and its properties are accessible
    if (window.parent && window.parent.location && window.parent.location.origin) {
      isWidgetOnSameDomain = window.location.origin === window.parent.location.origin;
    }
  } catch (e) {
    // Handle the case where access to window.parent is blocked
  }
}

const COLOR_MODE_KEY = 'logictry-color-mode';
function readColorMode() {
  try {
    return localStorage.getItem(COLOR_MODE_KEY) === 'dark' ? 'dark' : 'light';
  } catch (e) {
    return 'light';
  }
}
const colorMode = readColorMode();
const isDarkMode = colorMode === 'dark';

// Default colors — literals stay literal; semantic surfaces follow colorMode
const White = 'white';
const Black = 'black';
const StaticGray = isDarkMode ? '#000' : '#fafafa';
const FacebookBlue = '#3966b8';
const TwitterBlue = '#1b67f2';
const LinkedInBlue = '#0077b5';
const LightFacebookBlue = '#6d84b4';
const InstagramPurple = '#C13584';
const DisabledColor = isDarkMode ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)';
const DisabledBackgroundColor = isDarkMode ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.7)';
const ButtonShadow = isDarkMode ? 'rgba(255, 255, 255, 0.12) 0 0 2.5rem 0' : 'rgba(0, 0, 0, 0.3) 0 0 2.5rem 0';
const ImageHoverOverlay = 'rgba(255, 246, 170, 0.15)';
const CardShadow = isDarkMode ? 'rgba(255, 255, 255, 0.12) 0 0.125rem 0.25rem 0' : 'rgba(0, 0, 0, 0.3) 0 0.125rem 0.25rem 0';
const BoxShadow = isDarkMode ? '0 0.0625rem 0.375rem rgba(255,255,255,0.18)' : '0 0.0625rem 0.375rem rgba(0,0,0,0.4)';
const CTAShadow = isDarkMode ? 'rgba(255, 255, 255, 0.08) 0px 8px 23px 0px' : 'rgba(0, 0, 0, 0.1) 0px 8px 23px 0px';
const SubtleShadow = isDarkMode ? '0 2px 2px rgba(255, 255, 255, 0.08)' : '0 2px 2px rgba(0, 0, 0, 0.08)';
const SubtleShadowLeft = isDarkMode ? '-1px 0 3px rgba(255, 255, 255, 0.12)' : '-1px 0 3px rgba(0, 0, 0, 0.12)';
const LightBorderColor = isDarkMode ? 'rgba(255, 255, 255, 0.18)' : '#dbdbdb';
const LightBorder = `1px solid ${LightBorderColor}`;
const MediumBackground = isDarkMode ? '#000' : '#f2f2f2';
const LightBackground = isDarkMode ? '#000' : '#f9f9f9';
const MidnightBlue = '#0f1f3d';
const RoyalBlue = '#145aff';
const SkyBlue = '#47c1fe';
const MediumGray = isDarkMode ? '#a0a4ad' : '#40454f';
const Coral = '#ff7847';
const LightGray = '#c7cad1';
const Gainsboro = isDarkMode ? '#000' : '#e1e4eb';
const WhiteSmoke = isDarkMode ? '#000' : '#f1f3f6';
const DarkTextColor = isDarkMode ? '#fff' : '#111';
const MediumTextGray = isDarkMode ? '#aaa' : '#777';
const LightTextGray = isDarkMode ? '#ddd' : '#444';
const DefaultLogo = 'https://cdn.logictry.com/eyJidWNrZXQiOiJsb2dpY3RyeXN0YXRpYyIsImtleSI6ImltYWdlcy9sb2dvMDYyNjIzLnN2ZyIsImVkaXRzIjp7fX0=';
const DefaultLogoWhite = 'https://logictrystatic.s3.us-east-1.amazonaws.com/images/logo_white.png';
const LogicBaseCanvasFade = isDarkMode ? '#000' : '#fff';
const LogicBaseCanvasGradient = isDarkMode ? '#000' : '#fff';
const LogicBaseHeaderScrim = isDarkMode ? '#000' : '#fff';
/** Elevated cards, popups, menus — off-black so they sit on the page canvas. */
const SurfaceColor = isDarkMode ? '#161616' : White;
const SurfaceHover = isDarkMode ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.04)';
const DashedBorderColor = isDarkMode ? 'rgba(255, 255, 255, 0.22)' : 'rgba(0, 0, 0, 0.22)';
try {
  document.documentElement.style.colorScheme = isDarkMode ? 'dark' : 'light';
} catch (e) {
  // SSR / restricted document
}
const LogicBaseFloatShadow = isDarkMode ? '0 1px 2px rgba(255, 255, 255, 0.06), 0 8px 32px rgba(255, 255, 255, 0.08)' : '0 1px 2px rgba(0, 0, 0, 0.04), 0 8px 32px rgba(0, 0, 0, 0.07)';
const LogicBaseContentShadow = isDarkMode ? '0 0 1px rgba(255, 255, 255, 0.12), 0 2px 6px rgba(255, 255, 255, 0.08), 0 6px 16px rgba(255, 255, 255, 0.08)' : '0 0 1px rgba(0, 0, 0, 0.05), 0 2px 6px rgba(0, 0, 0, 0.06), 0 6px 16px rgba(0, 0, 0, 0.07)';
const StudioCanvasFade = isDarkMode ? '#000' : '#fff';
const StudioCanvasGradient = isDarkMode ? '#000' : '#fff';
const StudioFloatShadow = isDarkMode ? '0 1px 2px rgba(255, 255, 255, 0.06), 0 8px 32px rgba(255, 255, 255, 0.08)' : '0 1px 2px rgba(0, 0, 0, 0.04), 0 8px 32px rgba(0, 0, 0, 0.07)';

// Detect if valid color
const isColor = (strColor) => {
  const s = new Option().style;
  s.color = strColor;
  return s.color !== '';
}

// Allow for company themes
const theme = {};
if (window.logictry && window.logictry.company && window.logictry.company.theme) {
  Object.keys(window.logictry.company.theme).forEach((key) => {
    theme[key.toLowerCase()] = window.logictry.company.theme[key];
  });
}

// Set colors based on whether a query param, company theme, or default
const colors = {
  PrimaryColor: getPropertyQueryOrTheme('primarycolor', '#1ebd53'),
  BackgroundColor: getPropertyQueryOrTheme('backgroundcolor', isDarkMode ? Black : White),
  Logo: getPropertyQueryOrTheme('logo', isDarkMode ? DefaultLogoWhite : DefaultLogo, true),
  LogoIcon: getPropertyQueryOrTheme('logoicon', 'https://cdn.logictry.com/eyJidWNrZXQiOiJsb2dpY3RyeXN0YXRpYyIsImtleSI6ImltYWdlcy9pY29uMDYyNjIzLnN2ZyIsImVkaXRzIjp7fX0=', true),
  // Original https://logictryuserfiles.s3.amazonaws.com/5cf13c4899397a33fd191007/f9df6454b26ce055592d615f6aec9ec7/avatar.jpg
  Avatar: 'https://cdn.logictry.com/eyJidWNrZXQiOiJsb2dpY3RyeXVzZXJmaWxlcyIsImtleSI6IjVjZjEzYzQ4OTkzOTdhMzNmZDE5MTAwNy9mOWRmNjQ1NGIyNmNlMDU1NTkyZDYxNWY2YWVjOWVjNy9hdmF0YXIuanBnIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoyMTAsImhlaWdodCI6MjEwLCJmaXQiOiJjb3ZlciJ9fX0=',
  // Original https://logictrystatic.s3.amazonaws.com/images/verifiedbadge072223.png
  VerifiedBadge: 'https://cdn.logictry.com/eyJidWNrZXQiOiJsb2dpY3RyeXN0YXRpYyIsImtleSI6ImltYWdlcy92ZXJpZmllZGJhZGdlMDcyMjIzLnBuZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6bnVsbCwiaGVpZ2h0Ijo2NCwiZml0IjoiY292ZXIifX19',
  // Original https://logictryuserfiles.s3.amazonaws.com/5cf13c4899397a33fd191007/b3af86d02b00ba06b5b30f9cbeb2c5c4/logiccircle.png
  LogicCircle: 'https://cdn.logictry.com/eyJidWNrZXQiOiJsb2dpY3RyeXVzZXJmaWxlcyIsImtleSI6IjVjZjEzYzQ4OTkzOTdhMzNmZDE5MTAwNy9iM2FmODZkMDJiMDBiYTA2YjViMzBmOWNiZWIyYzVjNC9sb2dpY2NpcmNsZS5wbmciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjI0MCwiaGVpZ2h0IjoyNDAsImZpdCI6ImNvdmVyIn19fQ==',
  // Original https://logictrystatic.s3.amazonaws.com/js/d3.min.js
  D3Library: 'https://cdn.logictry.com/js/d3.min.js',
  // Original https://logictrystatic.s3.amazonaws.com/js/cloud.min.js
  CloudLibrary: 'https://cdn.logictry.com/js/cloud.min.js',
  // Original https://logictrystatic.s3.amazonaws.com/js/pdf.es5.js
  PDFJS: 'https://cdn.logictry.com/js/pdf.es5.js',
  // Original https://logictrystatic.s3.amazonaws.com/js/mammoth.browser.min.js
  MammothJS: 'https://cdn.logictry.com/js/mammoth.browser.min.js',
  // Original https://logictrystatic.s3.amazonaws.com/js/pdf.worker.min.js
  PDFWorker: 'https://cdn.logictry.com/js/pdf.worker.min.js',
};
function getPropertyQueryOrTheme(_prop, _default, _notColor) {
  return (theme && (_notColor || isColor(theme[_prop])) && theme[_prop] || _default);
}

const urlWithoutOrigin = window.location.href.replace(window.location.origin, '');
const logictryOrigin = window.logictry?.origin || window.location.origin;

// Default sizing
const BannerTextFontSize = '4rem';
const VeryLargeFontSize = '2rem';
const LargeFontSize = '1.5rem';
const SemiLargeFontSize = '1.17rem';
const NormalFontSize = '1rem';
const TabLabelFontSize = '0.9375rem';
const SemiSmallFontSize = '0.875rem';
const SmallFontSize = '0.75rem';
const VerySmallFontSize = '0.675rem';
const NormalSectionMargin = '1.875rem auto';
const NormalSectionPadding = '1.875rem 0';
const MaxWidth = '68rem';

/** Shared page + header side inset — wide enough to breathe, tight enough to stay full-bleed. */
const LogicBasePageGutter = '1.5rem';
const LogicBasePageGutterCompact = '1rem';
const LogicBaseFeedGap = '2rem';
const LogicBaseFeedTopOffset = '1.25rem';
const LogicBaseRootPaddingFull = '1.75rem 0 4.5rem';
const LogicBaseRootPaddingCompact = '1rem 1rem 3rem';

const MobileWidth = 500;
const TabletWidth = 960;
const NativeHeaderPaddingTop = '1.375rem';
const NativeiPhoneHeaderHeight = '4.375rem';
const NativeHeaderHeight = '5rem';
const MobileHeaderHeight = '3.5rem';
const DesktopHeaderHeight = '3.5rem';
const NativeTabBarHeight = '2.875rem';
const NativeTabBarPaddingBottom = '0';
const PopupMaxHeight = `max-height: calc(100vh - 6rem);
max-height: calc(100dvh - 6rem);`;
const PopupHeight = `height: calc(100vh - 6rem);
height: calc(100dvh - 6rem);`;
const NormalTransitionTime = '0.5s';
const UserInfoPopupMaxWidth = '400px';
const ListPopupWidth = '600px';

const TreeContentIndent = '2.5rem';
const TreeContentHalfIndent = '1rem';
const TreeContentIconIndent = '1.75rem';
const TreeAnswerIndent = '2rem';

const MindmapRoot = 'darkred';
const MindmapQuestion = '#D1E4D1';
const MindmapAnswer = '#AFE3C5';
const MindmapModule = '#1ebd53';
const MindmapDefault = '#187E52';
const ButtonHoverLightenFilter = 'brightness(120%)';
const HairlineBorderRgba = isDarkMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.08)';
const BottomBorderDivider = `1px solid ${HairlineBorderRgba}`;

const FacebookPage = 'https://www.facebook.com/logictry/';
const InstagramPage = 'https://www.instagram.com/logictry/';
const TwitterPage = 'https://twitter.com/logictry';
const LinkedInPage = 'https://www.linkedin.com/company/logictry/';
const YouTubePage = 'https://www.youtube.com/@logictry';
const TikTokPage = 'https://tiktok.com/@logictry';

const AppleStore = 'https://apps.apple.com/app/id6478935529';
const GoogleStore = 'https://play.google.com/store/apps/details?id=com.logictry.app';

const PaginationCount = 12;
const BoxSize = 180;
const SmallBoxSize = 120;
const BoxRadius = 16;

class Constants {
  constructor() {
    const properties = {
      ...colors,
      logictryOrigin,
      urlWithoutOrigin,
      documentReferrer,
      apikey,
      isDevelopment,
      isWidget,
      isWidgetOnSameDomain,
      isApp,
      isIphone,
      isLogicWiki,
      colorMode,
      isDarkMode,
      colorModeKey: COLOR_MODE_KEY,
      LogicBaseCanvasFade,
      LogicBaseCanvasGradient,
      LogicBaseHeaderScrim,
      SurfaceColor,
      SurfaceHover,
      DashedBorderColor,
      LogicBaseFloatShadow,
      LogicBaseContentShadow,
      StudioCanvasFade,
      StudioCanvasGradient,
      StudioFloatShadow,
      isAndroid,
      isIOS,
      TreeContentIndent,
      TreeContentHalfIndent,
      TreeContentIconIndent,
      TreeAnswerIndent,
      BottomBorderDivider,
      HairlineBorderRgba,
      NativeHeaderPaddingTop,
      NativeHeaderHeight,
      NativeiPhoneHeaderHeight,
      MobileHeaderHeight,
      DesktopHeaderHeight,
      NativeTabBarHeight,
      NativeTabBarPaddingBottom,
      PopupMaxHeight,
      PopupHeight,
      DisabledBackgroundColor,
      MidnightBlue,
      RoyalBlue,
      SkyBlue,
      Coral,
      LightGray,
      Gainsboro,
      WhiteSmoke,
      White,
      StaticGray,
      MediumGray,
      DarkBlue: '#2b2d42',
      DarkTextColor,
      MediumTextGray,
      LightTextGray,
      Black,
      FacebookBlue,
      TwitterBlue,
      LinkedInBlue,
      LightFacebookBlue,
      InstagramPurple,
      MindmapRoot,
      MindmapQuestion,
      MindmapAnswer,
      MindmapModule,
      MindmapDefault,
      ButtonTextColor: White,
      ButtonHoverLightenFilter,
      ButtonShadow,
      CardShadow,
      BoxShadow,
      CTAShadow,
      SubtleShadow,
      SubtleShadowLeft,
      LightBorderColor,
      LightBorder,
      MediumBackground,
      LightBackground,
      InputDisabledColor: DisabledColor,
      ImageHoverOverlay,
      NormalSectionMargin,
      NormalSectionPadding,
      BannerTextFontSize,
      VeryLargeFontSize,
      LargeFontSize,
      SemiLargeFontSize,
      NormalFontSize,
      TabLabelFontSize,
      SemiSmallFontSize,
      SmallFontSize,
      VerySmallFontSize,
      MobileWidth,
      TabletWidth,
      UserInfoPopupMaxWidth,
      ListPopupWidth,
      LogicBaseFeedGap,
      LogicBaseFeedTopOffset,
      LogicBasePageGutter,
      LogicBasePageGutterCompact,
      LogicBaseRootPaddingCompact,
      LogicBaseRootPaddingFull,
      MaxWidth,
      NormalTransitionTime,
      MediaDesktop: `@media (min-width: ${TabletWidth}px)`,
      MediaTablet: `@media (min-width: ${MobileWidth}px) and (max-width: ${TabletWidth - 1}px)`,
      MediaMobile: `@media (max-width: ${MobileWidth - 1}px)`,
      MediaMobileAndTablet: `@media (max-width: ${TabletWidth - 1}px)`,
      MediaTabletAndDesktop: `@media (min-width: ${MobileWidth}px)`,
      MediaStaticMaxWidth: `@media (max-width: 80rem)`,
      StaticContentMaxWidth: 'max-width: 80rem;',
      StaticTextMaxWidth: 'max-width: 60rem;',
      desktop: "only screen and (min-width: 1400px) and (max-width: 1920px)",
      laptop: "only screen and (min-width: 1200px) and (max-width: 1399px)",
      lg: "only screen and (min-width: 992px) and (max-width: 1199px)",
      md: "only screen and (min-width: 768px) and (max-width: 991px)",
      xs: "(max-width: 767px)",
      sm: "only screen and (min-width: 576px) and (max-width: 767px)",
      FacebookPage,
      InstagramPage,
      TwitterPage,
      LinkedInPage,
      YouTubePage,
      TikTokPage,
      AppleStore,
      GoogleStore,
      PaginationCount,
      BoxSize,
      SmallBoxSize,
      BoxRadius,
    };
    Object.keys(properties).forEach((_key) => {
      this[_key] = properties[_key];
    });
    this.InputBorderBottom = isDarkMode
      ? `border-bottom: 0.0625rem solid rgba(255, 255, 255, 0.42);`
      : `border-bottom: 0.0625rem solid rgba(0, 0, 0, 0.42);`;
    this.defaultLineHeight = '1.3125rem';
    this.defaultLinePadding = '0.59375rem';
    this.WarningTextColor = this.PrimaryColor;
    this.CancelTextColor = this.DarkTextColor;
    this.ConfirmTextColor = this.PrimaryColor;
    this.ButtonActiveColor = this.PrimaryColor;
    this.InternetDisabledColor = this.PrimaryColor;
    this.GradientBackground = `
      background: radial-gradient(circle farthest-side at center bottom, ${this.LightPrimaryColor}, ${this.DarkPrimaryColor} 100%);
    `;
    this.LinearGradientBackground = `
      background: linear-gradient(to bottom left,#42b618,#06680e 100%);
    `;
  }

  setColorMode(mode) {
    const next = mode === 'dark' ? 'dark' : 'light';
    try {
      localStorage.setItem(COLOR_MODE_KEY, next);
    } catch (e) {
      // Private mode — still reload so a query/session override can apply later
    }
    window.location.reload();
  }
}

const singleton = new Constants();
export default singleton;
